// eslint-disable-next-line no-unused-vars
import React from 'react';

import { reportClientEvent as reportEvent } from '@lusha-growth/bi-client-sdk';

const reportClientEvent = ({ platform = 'plugin', subPlatform = 'linkedin', pageUrl, ...metadata }) => {
  reportEvent({
    teamName: 'plugin',
    isLoggedIn: true,
    metadata: {
      platform,
      subPlatform,
      pageUrl,
      ...metadata,
    },
  });
};

export default reportClientEvent;
